import {APIRequest} from "./APIRequest.js";

export const API_URL = 'https://pubfguv67uujstnnqnklpza46m0jzfto.lambda-url.us-east-1.on.aws/';

export const puppeteerCreateShareChatScreenshot = async (kbId, shareId) => {
    return await APIRequest('get',API_URL + `?kbId=${encodeURIComponent(kbId)}&shareId=${encodeURIComponent(shareId)}`);
}